import config from "../src/AppConfig.json";

export const AppConfig = config;
